/* eslint-disable */
/**
 * Возвращает объект типа FormData для axios запроса
 *
 * @param data {Object} Объект со списком отправляемых в запрос данных
 */
export default function formData(data) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
    });

    return formData;
};
